import axios from "axios";
import { Buffer } from "buffer";
import { jsPDF } from "jspdf";

class BrowserImageCoverter {
  // imageTypes = ["JPEG", "PNG", "GIF"];
  imageTypes = ["JPEG", "PNG", "GIF", "PDF", "WEBP"];
  async getImageBase64FromUrl(url) {
    if (typeof url !== 'string') {
        throw new Error('URL must be a string');
    }
    const options = {
        method: "GET",
        url,
        responseType: "arraybuffer",
    };
    try {
        const response = await axios(options);
        if (response && response.data) {
            return Buffer.from(response.data, "binary").toString("base64");
        } else {
            throw new Error('Response data is empty');
        }
    } catch (error) {
        console.error('Error fetching image:', error);
        throw error;
    }
}


  downloadImageFromBase64( imageType, fileName, url) {
    

    if (imageType === "JPEG") {
      fileName = fileName.substring(0, fileName.lastIndexOf("."));
      let img = new Image();
      img.onload = function () {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, img.width, img.height);
        ctx.drawImage(img, 0, 0); // Or at whatever offset you like
        const dataURI = canvas.toDataURL("image/jpeg", 1.0);
        //  console.log(dataURI);

        const imageEl = document.createElement("a");
        imageEl.href = dataURI;
        imageEl.download = `${fileName}.${imageType}`;
        document.body.appendChild(imageEl);
        imageEl.click();
        // console.log(imageEl);
        // remove element
        if (imageEl.parentNode) {
          document.body.removeChild(imageEl);
        }
      };
      img.src = url;
    }

    if (imageType === "PNG") {
      fileName = fileName?.substring(0, fileName?.lastIndexOf(".")) || fileName;
      const imageEl = document.createElement("a");
      imageEl.href = url;
      imageEl.download = `${fileName}.${imageType}`;
      document.body.appendChild(imageEl);
      imageEl.click();
      // console.log(imageEl);
      // remove element
      if (imageEl.parentNode) {
        document.body.removeChild(imageEl);
      }
    }
    if ( imageType === "GIF") {
      fileName = fileName.substring(0, fileName.lastIndexOf("."));
      const imageEl = document.createElement("a");
      imageEl.href = url;
      imageEl.download = `${fileName}.${imageType}`;
      document.body.appendChild(imageEl);
      imageEl.click();
      // console.log(imageEl);
      // remove element
      if (imageEl.parentNode) {
        document.body.removeChild(imageEl);
      }
    }

    if (imageType === "PDF") {
      fileName = fileName.substring(0, fileName.lastIndexOf("."));

      //// JSPDF extensions variables
      var doc = new jsPDF({
        orientation: "p",
        unit: "mm",
        compress: true,
      });

      //// Adds an Image to the PDF.
      doc.addImage(url, 10, 10, "", "", "", "FAST");

      doc.save(`${fileName}.pdf`);
    }
    if (imageType === "WEBP") {
      fileName = fileName.substring(0, fileName.lastIndexOf("."));
      let img = new Image();
      img.crossOrigin = "anonymous"; 
    
      img.onload = function () {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
    
        // Resize very large images to reduce file size (max 1920px on longest side)
        const maxDimension = 1920;
        let width = img.width;
        let height = img.height;
        
        if (width > maxDimension || height > maxDimension) {
          if (width > height) {
            height = (height / width) * maxDimension;
            width = maxDimension;
          } else {
            width = (width / height) * maxDimension;
            height = maxDimension;
          }
        }
    
        canvas.width = width;
        canvas.height = height;
    
        ctx.drawImage(img, 0, 0, width, height); 
        // Use quality 0.8 to reduce file size while maintaining good visual quality
        const dataURI = canvas.toDataURL("image/webp", 0.8); 
    
        const imageEl = document.createElement("a");
        imageEl.href = dataURI;
        imageEl.download = `${fileName}.webp`;
        document.body.appendChild(imageEl);
        imageEl.click();
    
        if (imageEl.parentNode) {
          document.body.removeChild(imageEl);
        }
      };
      img.src = url;
    }

  }

  downloadImageWithType = (
    url = String,
    imageType = "jpeg",
    fileName = "converted_image"
  ) => {
    if (url === "") {
      throw new Error("Please check your image URL!");
    }
    if (!this.imageTypes.includes(imageType?.toUpperCase())) {
      throw new Error("Image type must be: JPEG, PNG or GIF");
    }

  //  this.getImageBase64FromUrl(url)

    //  .then((base64) => {
      //console.log(url)
        this.downloadImageFromBase64( imageType, fileName, url);
    //  })
     // .catch((err) => console.error(err));
  };
}

const browserImageCoverter = new BrowserImageCoverter();
Object.freeze(browserImageCoverter);
window.browserImageCoverter = browserImageCoverter;
export default browserImageCoverter;
